import SignupLayout from '../ui-components/SignupLayout';
import { useParams, useSearchParams } from 'react-router-dom';
import SignupForm from './SignupForm';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SignupPage.module.css';
import Button, { ButtonType } from '../general-components/Button';
import SignupContext from '../../store/signup-context';
import { CircleCheck } from 'lucide-react';

const DisabledSignup = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <h3 style={{ width: '400px' }}>
                {t('signup.signupPage.disabledSignup.title')} <br />
                <br /> {t('signup.signupPage.disabledSignup.contact')}
            </h3>
        </React.Fragment>
    );
};

const WrongInvitationSignup = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <h3 style={{ width: '400px' }}>
                {t('signup.signupPage.wrongInvitation.title')}
                <br />
                <br /> {t('signup.signupPage.wrongInvitation.contact')}
            </h3>
        </React.Fragment>
    );
};

export const ConfirmedSignup = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <CircleCheck size={'75px'} strokeWidth={'0.75px'} />
            <h3>{t('signup.signupPage.confirmedSignup.title')}</h3>
            <p>{t('signup.signupPage.confirmedSignup.description')}</p>
            <Button
                small
                className={styles.button}
                type={ButtonType.primary}
                onClick={() => {
                    window.location.href = '/';
                }}
            >
                {t('signup.signupPage.confirmedSignup.button')}
            </Button>
        </React.Fragment>
    );
};

const PaymentMissing = () => {
    const { t } = useTranslation();
    return (
        <>
            <h3>{t('signup.signupPage.paymentMissing.title')}</h3>
            <p>{t('signup.signupPage.paymentMissing.description')}</p>
            <Button
                className={styles.button}
                type={ButtonType.primary}
                onClick={() => (window.location.href = '/payment')}
            >
                {t('signup.signupPage.paymentMissing.button')}
            </Button>
        </>
    );
};

const SignupPage = () => {
    const {
        fetchSignupData,
        setDefaultEmail,
        setId,
        currentElement,
        id,
        setFormData,
        defaultEmail,
    } = useContext(SignupContext);

    let { code } = useParams<{ code: string }>();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (id !== '' && defaultEmail !== '') {
            fetchSignupData();
        }
    }, [id, defaultEmail]);

    useEffect(() => {
        const email = searchParams.get('email');

        setDefaultEmail(email);
        setFormData({
            type: 'update',
            name: 'email',
            value: email,
        });
        setId(searchParams.get('invite') || code);
    }, []);

    return (
        <SignupLayout>
            {currentElement === 'signup' && <SignupForm />}
            {currentElement === 'disabled' && <DisabledSignup />}
            {currentElement === 'wrong' && <WrongInvitationSignup />}
            {currentElement === 'confirm' && code !== 'trial' && (
                <ConfirmedSignup />
            )}
            {currentElement === 'payment-missing' && <PaymentMissing />}
        </SignupLayout>
    );
};

export default SignupPage;
